import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/projects')({
  beforeLoad: ({ location }) => {
    const token = localStorage.getItem('access_token');
    const userData = localStorage.getItem('user_data');
    if (!token || !userData) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: () => <Outlet />,
});
